import {
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  HostBinding,
  Input,
  TemplateRef,
  ViewChild,
} from "@angular/core";

import { MedTemplateDirective } from "../../../directives/med-template.directive";
import { NgStyleType } from "../../../types";

export type MedSidebarPositionType = "top" | "bottom" | "left" | "right";

@Component({
  selector: "med-sidebar",
  templateUrl: "./med-sidebar.component.html",
  styleUrls: ["./med-sidebar.component.scss"],
})
export class MedSidebarComponent implements AfterViewInit {

  private _dimensions!: DOMRect;

  btnTemplate?: TemplateRef<any>;

  @Input() show = true;
  @Input() position: MedSidebarPositionType = "left";
  @Input() closedSize = "0px";

  @ViewChild("contentRef") contentRef!: ElementRef<HTMLElement>;

  @ContentChild(MedTemplateDirective) template?: MedTemplateDirective;

  @HostBinding("class") get class(): string {
    const BASE_CLASS = "med-sidebar";
    const flexible = this.btnTemplate ? "flexible" : "";

    return [BASE_CLASS, this.position, flexible].join(" ");
  }

  get styleList(): NgStyleType {
    if (!this._dimensions) {
      return null;
    }

    const isPositionHorizontal = ["top", "bottom"].includes(this.position);
    const position = isPositionHorizontal ? "height" : "width";
    const size = this.show ? `${this._dimensions[position]}px` : this.closedSize;
    return {
      [position]: size,
    };
  }

  ngAfterViewInit(): void {
    if (this.template?.getType() === "btn") {
      this.btnTemplate = this.template.template;
    }

    this._setContainerDimensions();
  }

  private _setContainerDimensions = () => setTimeout(() => {
    this._dimensions = this.contentRef.nativeElement.getBoundingClientRect();
  }, 0);
}
